import React from 'react'

const BrowserInvalido = () => {
    return (
        <div>

        </div>
    )
}

export default BrowserInvalido;